
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 115.04 144.29"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"CRS Development"}},[_c('path',{attrs:{"data-name":"Stage - Development","d":"M47.17 68.75l5.09 2.76q14.35 7.74 30.28-.21a51.2 51.2 0 0022.26-22.09A38.81 38.81 0 00108.4 20q6.16 15.62 6.55 21 .83 9.23-6 21.79a39 39 0 01-21.11 18.4q-13.64 5.13-24.61-.14L52.59 93.63c.2-1.58-.68-3.66-2.65-6.26a16.54 16.54 0 00-5.19-5l-1-.56 5.89-8.66-1.36-.73-6.51 9-3.5-.42zM61.92 2.89Q77.58-3.35 91 3.9q27.25 14.73 11.28 44.28a47.46 47.46 0 01-21.92 21.07Q64.88 76.57 50.87 69q-13.41-7.24-16-20.51-2.46-12.29 4.92-26a42.22 42.22 0 0122.13-19.6zm-23.83 44.5q2.37 12 14.6 18.64 12.66 6.84 26.78.21a43 43 0 0020-19.14Q113.92 20.34 89.29 7 77.07.42 62.85 6a37.8 37.8 0 00-20.21 17.74q-6.75 12.48-4.55 23.65zm-33 78.5l31.16-42.41a5.6 5.6 0 016.1-.33 19.45 19.45 0 017.09 6.36c1.87 2.77 2.18 5 .91 6.64L17.14 141a8.13 8.13 0 01-4.89 2.95 9.66 9.66 0 01-7.25-.79 9.28 9.28 0 01-4.41-5.23 7.58 7.58 0 01.29-6.43zM62.41 9.08q13.1-5.55 24.13.42a23.19 23.19 0 017.28 6Q81.1 9.21 68.74 13.21T49.57 29.79q-7 12.9-3 30-12.3-16.1-2.57-34.11a36.53 36.53 0 0118.41-16.6zm7.81 13.76a20.19 20.19 0 0113.47 1.68q-9 3.69-11.35 5a21.14 21.14 0 00-8.72 8.23 98.28 98.28 0 00-4.29 10q-3.63-10 .24-17.1a15.17 15.17 0 0110.65-7.81z","fill":"#fff"}})])])])
          )
        }
      }
    